const types = [
  {
    path: '/types',
    name: 'type.list',
    component: () => import('@/views/types/TypeList.vue'),
  },
]

export default types
